<template>
  <div>
    <a-button
      v-ripple
      @click="show"
      type="primary"
      :title="title"
    >
      <i
        class="mdi mdi-plus increased"
        v-if="mode === 'new'" />
      <i
        class="mdi mdi-pencil-circle-outline"
        v-if="mode !== 'new'" />
    </a-button>
    <a-drawer
      :width="700"
      :title="'widget-access-key-details.title' | globalize"
      placement="right"
      :visible="visible"
      :footer-style="{ textAlign: 'right' }"
      @close="onCancel"
    >
      <a-form
        :form="form"
        layout="horizontal"
      >
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'widget-access-key-details.lbl-client-id' | globalize"
        >
          <a-input
            :placeholder="'widget-access-key-details.help-client-id' | globalize"
            :disabled="mode !== 'new' || loading"
            v-decorator="[
              'clientId',
              { rules: [
                { required: true, message: 'Please input client id' },
              ]
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          has-feedback
          :label="'widget-access-key-details.lbl-domain' | globalize"
        >
          <a-input
            :placeholder="'widget-access-key-details.help-domain' | globalize"
            :disabled="loading"
            v-decorator="[
              'domain',
              {
                rules: [
                  { required: true, message: 'Please input domain' },
                  { validator: validateDomain }
                ]
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"

          :label="'widget-access-key-details.lbl-key' | globalize"
        >
          <a-input
            :placeholder="'widget-access-key-details.help-key' | globalize"
            :disabled="loading"
            v-decorator="[
              'key',
              { rules: [{ required: true, message: 'Please input key' }] },
            ]"
          >
            <a-button
              style="margin-right: 8px"
              :loading="loading"
              slot="addonAfter"
              @click="onGenerateKey">
              {{ 'widget-access-key-details.generate' | globalize }}
            </a-button>
          </a-input>
        </a-form-item>
        <a-divider />

        <template v-if="errorMessage">
          <a-alert
            type="error"
            :message="errorMessage" />
        </template>
        <a-form-item :wrapper-col="{ offset: 8, span: 16 }">
          <a-button
            style="margin-right: 8px"
            :loading="loading"
            @click="onCancel">
            {{ 'widget-access-key-details.cancel' | globalize }}
          </a-button>
          <a-button
            type="primary"
            :loading="loading"
            @click="onSubmit">
            {{ 'widget-access-key-details.save' | globalize }}
          </a-button>
        </a-form-item>
      </a-form>
    </a-drawer>
  </div>
</template>

<script>
import AForm from 'ant-design-vue/lib/form'
import AInput from 'ant-design-vue/lib/input'
import ADivider from 'ant-design-vue/lib/divider'
import AButton from 'ant-design-vue/lib/button'
import ADrawer from 'ant-design-vue/lib/drawer'
import AAlert from 'ant-design-vue/lib/alert'
import { globalize } from '@/vue/filters/globalize'
import { makeRandomString } from '@/js/helpers/string'
import { Bus } from '@/js/helpers/event-bus'

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
}
const formTailLayout = {
  labelCol: { span: 16 },
  wrapperCol: { span: 16, offset: 16 },
}

export default {
  name: 'widget-access-key-editor',
  components: {
    AForm,
    AInput,
    ADivider,
    AFormItem: AForm.Item,
    AButton,
    ADrawer,
    AAlert,
  },
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    mode: {
      type: String,
      default: 'new',
    },
    details: {
      type: Object,
      default: () => {},
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    onAdd: {
      type: Function,
      default: () => {},
      required: true,
    },
  },
  data () {
    return {
      visible: false,
      formItemLayout,
      formTailLayout,
      errorMessage: '',
      form: this.$form.createForm(this, {
        name: 'widget-access-key',
      }),
    }
  },
  created () {
    Bus.on('widget-access-key-details-updated', this.onCancel)
  },
  destroyed () {
    Bus.resetEvent('widget-access-key-details-updated')
  },
  methods: {
    onSubmit () {
      this.form.validateFields(async (err, values) => {
        this.errorMessage = ''

        if (err) return

        const { error } = await this.onAdd(values, this.mode)
        if (error && /Client ID already exists/.test(error._detail)) {
          this.errorMessage = globalize('widget-access-key-details.error-exists')
        }
      })
    },
    onCancel () {
      this.visible = false
    },
    show () {
      Object.keys(this.details).forEach(key => {
        this.form.getFieldDecorator(key, { initialValue: this.details[key] })
      })

      this.visible = !this.visible
    },
    onGenerateKey () {
      const key = makeRandomString()
      this.form.setFields({ key: { value: key } })
    },

    validateDomain (rule, value, callback) {
      /* eslint-disable-next-line */
      if (value && /(localhost)((:)+(\d)+)*/.test(value)) {
        callback()
        return
      }

      if (value && /^(http|https):\/\/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/.test(value)) {
        callback()
        return
      }
      /* eslint-disable-next-line */
      callback('Should be valid domain name.Example: http://domain.com, https://domain.com')
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '~ant-design-vue/lib/alert/style/index.css';
  @import '~ant-design-vue/lib/button/style/index.css';
  @import '~ant-design-vue/lib/input/style/index.css';
  @import '~ant-design-vue/lib/divider/style/index.css';
  @import '~ant-design-vue/lib/form/style/index.css';
  @import '~ant-design-vue/lib/drawer/style/index.css';
</style>
